<template>
	<div class="dashboard-page">
    <DashboardTopBar :categoryname="categoryname" :dashboardtitle="dashboardtitle" />

    <div class="select-bar single-code-analysis-top-search">
      <el-row :gutter="30">
        <el-col :span="4">
          <span>品类</span>
          <el-select v-model="querybody.levelValue" placeholder="请选择" size="small" popper-class="singlecodetopselect">
            <el-option 
              v-for="(item, index) in searchoptions" 
              :class="'select-' + item.levelname" 
              :key="item.value+item.levelname+index"
              :label="item.label"
              :value="item.value"
              @click.native="querybody.levelName = item.levelname">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4" v-if="show > 1">
          <span>{{$t('SingleCodeAnalysis.t02')}}</span>
          <el-select v-model="querybody.flow" placeholder="请选择" size="small" popper-class="singlecodetopselect">
            <el-option 
              v-for="item in searchflowoptions" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span>{{$t('SingleCodeAnalysis.t03')}}</span>
          <el-select v-model="querybody.index" placeholder="请选择" size="small" popper-class="singlecodetopselect">
            <el-option 
              v-for="item in searchindexoptions" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span>{{$t('SingleCodeAnalysis.t04')}}</span>
          <el-select v-model="querybody.unit" placeholder="请选择" size="small" v-if="querybody.index=='volume'" popper-class="singlecodetopselect">
            <el-option 
              v-for="item in searchunitoptions" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="querybody.currency" placeholder="请选择" size="small" v-if="querybody.index=='value'" popper-class="singlecodetopselect">
            <el-option 
              v-for="item in searchunitoptions2" 
              :key="item.value" 
              :label="item.label" 
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <span>{{$t('SingleCodeAnalysis.t05')}}</span>
          <el-date-picker
            :clearable="false"
            class="searchperiod"
            size="small"
            v-model="querybody.lastMonth"
            type="month"
            :picker-options="pickerOptions"
            popper-class="selectmonth"
            placeholder="选择月"
            format="yyyy-MM"
            value-format="yyyy-MM">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
        </el-col>
        <el-col :span="4">
          <div class="single-code-analysis-top-search-confirm">
            <el-button class="homeokbtn" type="primary" @click="confirmSelect()">OK</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <div class="dashboard-wrap">
      <P1 v-if="show == 1" :chartdata="chartdata" :searchperiod="querybody.lastMonth" :querydata="querybody" />
      <P2 v-if="show == 2" :chartdata="chartdata" :querydata="querybody" v-on:show-title="showtitle"/>
      <P3 v-if="show == 3" />
      <P4 v-if="show == 4" />
      <P5 v-if="show == 5" />
      <P6 v-if="show == 6" />
      <P7 v-if="show == 7" />
    </div>

    <div class="dashboard-navigation">
      <div class="chartpagegroup">
        <el-button type="text" icon="el-icon-arrow-left" :disabled="show == 1" @click="onPrevButton(show)"></el-button>
        <span class="chartpage">{{show}}/总页数14</span>
        <el-button type="text" icon="el-icon-arrow-right" :disabled="show == 14" @click="onNextButton(show)"></el-button>
      </div>      
    </div>

	</div>
</template>

<script>
import DashboardTopBar from '../../components/CombinationAnalysis/Commons/DashboardTopBar.vue'
import P1 from '../../components/CombinationAnalysis/Pages/P1.vue'
import P2 from '../../components/CombinationAnalysis/Pages/P2.vue'
import P3 from '../../components/CombinationAnalysis/Pages/P3.vue'
import P4 from '../../components/CombinationAnalysis/Pages/P4.vue'
import P5 from '../../components/CombinationAnalysis/Pages/P5.vue'
import P6 from '../../components/CombinationAnalysis/Pages/P7.vue'
import P7 from '../../components/CombinationAnalysis/Pages/P7.vue'
export default {
	components: {
		DashboardTopBar,
    P1, P2, P3, P4, P5, P6, P7
	},
	data(){
		return{
      categoryname: '',
			dashboardtitle: '',
      searchdatetype: '',
      querylast: '',
      queryflow: '',
			queryindex: '',
			queryunit: '',
      searchoptions: [],
      searchindexoptions: [{
        value: "value",
        label: this.$t('charttxt.t3')
      },{
        value: "volume",
        label: this.$t('charttxt.t4')
      }],
      searchflowoptions: [{
        value: 'import',
        label: this.$t('charttxt.t1')
      }, {
        value: 'export',
        label: this.$t('charttxt.t2')
      }],
      searchunitoptions: [{
        value: "first_unit",
        label: this.$t('charttxt.t7')
      }, {
        value: "second_unit",
        label: this.$t('charttxt.t8')
      }],
      searchunitoptions2: [{
        value: "usd",
        label: this.$t('charttxt.t5')
      },{
        value: "rmb",
        label: this.$t('charttxt.t6')
      }],
			querybody: {
        cid: this.$route.params.Cid,
        flow: 'import',
        index: 'value',
				unit: 'first_unit',
				currency: 'usd',
        lastMonth: '',
				levelName: '',
        levelValue: '',
        page: 1
			},
      chartdata: {},
			show: 0
		}
	},
  
  computed: {  
    pickerOptions() {
      let that=this
      return {
        disabledDate(time) {
          let newdateobj = new Date(that.querylast)
          let olddateobj = new Date('2018-12')
          let olddate = olddateobj.setMonth(olddateobj.getMonth())
          let newdate = newdateobj.setMonth(newdateobj.getMonth())
          return time.getTime() > newdate || time.getTime() < olddate
        }
      }
     }
  },

	mounted(){
    let that = this
    let defaultpage = 1
    that.show = defaultpage
		that.getCategoryInfo(function(){
      that.getCategoryTree(defaultpage, function(){
        that.getLastMonth(function(){
          that.getDashboard(defaultpage)
        })
      })
    })
	},

	methods: {

    /**
     * 确认按钮
     */
    confirmSelect: function(){
      this.getDashboard(this.show)
    },

		/**
		 * 图表翻页 - 上一页
		 */
		onPrevButton: function(page){
      let that = this
			let _p = page - 1
      that.getCategoryTree(_p, function(){
        that.getDashboard(_p)
      })
		},

		/**
		 * 图表翻页 - 下一页
		 */
		onNextButton: function(page){
      let that = this
			let _p = page + 1
      that.getCategoryTree(_p, function(){
        that.getDashboard(_p)
      })
		},
		
    /**
     * 最近月份
     */
    getLastMonth: function(callback){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/category/last-year-month?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
                  +'&cid='+that.$route.params.Cid+''
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log('getLastMonth', rex)
          that.querylast = rex.data.year_month
          that.querybody.lastMonth = rex.data.year_month
          callback()
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * Category Info
     */
    getCategoryInfo: function(callback){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/category/info?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
                  +'&cid='+that.$route.params.Cid+''
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log('getCategoryInfo', rex)
          that.categoryname = rex.data.name_cn
          that.querybody.levelValue = rex.data.name_cn
          callback()
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 子品类
     * http://dashboard.api.trade-intelligence.com/dashboard/category/page-category-tree
     */
    getCategoryTree: function(_page, callback){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/category/page-category-tree?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
                  +'&cid='+that.$route.params.Cid
                  +'&page='+_page
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log('getCategoryTree', rex.data.tree)
          that.searchoptions = that.setCategoryData(rex.data.tree)
          that.querybody.levelName = rex.data.tree.levelName
          callback()
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 获取图表数据
     */
    getDashboard: function(_page){
      let that = this
      let _query = {
        cid: that.querybody.cid,
        flow: _page > 1 ? that.querybody.flow : '',
        index: that.querybody.index,
        unit: that.querybody.unit,
        currency: that.querybody.currency,
        lastMonth: that.querybody.lastMonth,
        levelName: that.querybody.levelName,
        levelValue: that.querybody.levelValue,
        page: _page, 
      }
			let _baseurl = _page > 1 ? 
											'http://dashboard.api.trade-intelligence.com/dashboard/category/period?key=' : 
											'http://dashboard.api.trade-intelligence.com/dashboard/category/main?key='
      let url = _baseurl
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      let loading = that.$loading({
        lock: true,
        text: '数据加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        data: _query,
        success: function(rex) {
          console.log('getDashboard', rex)
          let data = rex.data
          that.chartdata = data

					// P1
					if(_query.page == 1){
						that.setPageTitle(_query)
						that.show = 1
						that.dashboardtitle = '行业进/出口' + that.queryindex + ' - ' + that.queryunit + '(' + data.export.MAT.unit + ')'
					}

					// P2
					if(_query.page == 2){
						that.setPageTitle(_query)
            that.dashboardtitle = ''
						that.show = 2
					}

					// P3
					if(_query.page == 3){
            that.dashboardtitle = '细分类别份额及增长率矩阵 – 第一计量单位 (百万升) – 滚动年累计'
						that.show = 3
					}

					// P4
					if(_query.page == 4){
						that.show = 4
            that.dashboardtitle = '细分类别增长趋势 – 第一计量单位 (百万升) – 滚动年累计 今年 vs. 去年'
					}

					// P6
					if(_query.page == 5){
						that.show = 5
            that.dashboardtitle = '贸易伙伴进口数量份额 - 第一计量单位 (百万升) – 滚动年累计 (2019-01 - 2019-12)'
					}

					// P6
					if(_query.page == 6){
						that.show = 6
            that.dashboardtitle = '贸易伙伴份额及增长率矩阵 - 第一计量单位 (百万升) – 滚动年累计 (2019-01 - 2019-12)'
					}

					// P7
					if(_query.page == 7){
						that.show = 7
            that.dashboardtitle = '前二十大贸易伙伴增长趋势 – 第一计量单位 (百万升) – 滚动年累计 今年 vs. 去年'
					}


          loading.close()
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

		/**
		 * 页面标题
		 */
		setPageTitle: function(_q){
      if(_q.flow == 'export'){
        this.queryflow = this.$t('charttxt.t2')
      }
      if(_q.flow == 'import'){
        this.queryflow = this.$t('charttxt.t1')
      }
			if(_q.index == 'volume'){
				this.queryindex = this.$t('charttxt.t4')
			}
			if(_q.index == 'value'){
				this.queryindex = this.$t('charttxt.t3')
			}
			if(_q.index == 'volume' && _q.unit == 'first_unit'){
				this.queryunit = this.$t('charttxt.t7')
			}
			if(_q.index == 'volume' && _q.unit == 'second_unit'){
				this.queryunit = this.$t('charttxt.t8')
			}
			if(_q.index == 'value' && _q.currency == 'rmb'){
				this.queryunit = this.$t('charttxt.t6')
			}
			if(_q.index == 'value' && _q.currency == 'usd'){
				this.queryunit = this.$t('charttxt.t5')
			}			
		},

    showtitle: function(data){
      let that = this
      let _m = that.moment(that.querybody.lastMonth).get('month')
      if(data.type == 0){
        that.searchdatetype = that.$t('SingleCodeAnalysis.t08') + '(' + that.moment(that.querybody.lastMonth).subtract(11, 'month').format("YYYY-MM") + ' - '
      }
      if(data.type == 1){
        that.searchdatetype = that.$t('SingleCodeAnalysis.t07') + '(' + that.moment(that.querybody.lastMonth).subtract(_m, 'month').format("YYYY-MM") + ' - '
      }
      if(data.type == 2){
        that.searchdatetype = that.$t('SingleCodeAnalysis.t06') + '(' + that.moment(that.querybody.lastMonth).subtract(2, 'month').format("YYYY-MM") + ' - '
      }
      if(data.type == 3){
        that.searchdatetype = '当月('
      }    
      that.dashboardtitle = that.querybody.levelValue + '子品类' + that.queryflow + that.queryindex + '份额及增长 - ' +
                            that.queryunit + '(' + data.unit + ') - ' + that.searchdatetype + that.querybody.lastMonth + ')'
      
    },

	}
}
</script>